<template>
  <div id="app">
    <Header></Header>
    <div>
      <Title></Title>
      <Progress></Progress>
      <Competition></Competition>
    </div>
    <Introduction></Introduction>
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Title from './components/Title.vue'
import Progress from './components/Progress.vue'
import Competition from './components/Competition.vue'
import Introduction from './components/Introduction.vue'

export default {
  name: 'App',
  components: {
    Header, Title, Progress, Competition, Introduction
  }
}
</script>

<style lang="less">
html, body {
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  cursor: default;
}
</style>
